// Home page for user support

import {
  Box,
  Button,
  Typography,
  ThemeProvider,
} from '@mui/material';
import getTheme from '../../theme/theme';
import { useNavigate } from 'react-router-dom';
import FloatingButton from './helpdesk/FloatingButton';

const UserSupportHomePage: React.FC = () => {
 
  const buttonStyles = {
    padding: '50px 50px', 
    fontSize: '1.1rem', 
    margin: '20px', 
    width: '250px',
    height: '200px', 
    borderRadius: '24px', 
  };

  const navigate = useNavigate();

  //navigate to demovideos page
  const handleDemoVideos = () => {
    navigate('/demovideos');
  };

   //navigate to training page
  const handleTraining = () => {
    navigate('/training');
  };
  
  //navigate to ticket page
  const handleTicket = () => {
    navigate('/ticket');
  };

  
 

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ marginTop: '-60px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ flex: 'auto', overflow: 'auto' }}>
            <Typography variant='h5' component='div'>
              User Support Home
            </Typography>
          </Box>
        </Box>

        <Box sx={{ marginTop: '20px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
              onClick={handleDemoVideos}
            >
              Basic Training
            </Button>

            {/* <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
            onClick={handleTraining}
            >
              Training
            </Button> */}
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '16px',
            }}
          >
            <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
             onClick={handleTicket}
            >
              Helpdesk
            </Button>
          </Box>
        </Box>
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
};

export default UserSupportHomePage;
